export { default } from "@casino/external/icons/SecurityShieldSecured";
